module.exports = __webpack_public_path__ + "static/media/nats-ticketfinder.69dac60c.jpg";